import request from '../request';
// cvs_to_job
export const cvsToJob = (params) => {
  return request({
    url: (process.env.NODE_ENV === 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + '/v4/recommender/cvs_to_job',
    method: 'GET',
    params,
  })
}

// joblist_to_job
export const jobListToJob = (data) => {
  return request({
    url: (process.env.NODE_ENV === 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + '/v4/recommender/joblist_to_job',
    method: 'POST',
    data,
  })
}

// editor_to_job
export const editorToJob = (params) => {
  return request({
    url: (process.env.NODE_ENV === 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + '/v4/recommender/editor_to_job',
    method: 'GET',
    params,
  })
}

// download_to_job
export const downloadToJob = (params) => {
  return request({
    url: (process.env.NODE_ENV === 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + '/v4/recommender/download_to_job',
    method: 'GET',
    params,
  })
}

// career_to_job
export const careerToJob = (data) => {
  return request({
    url: (process.env.NODE_ENV === 'development' ? '/hrapi' : process.env.HRAPI_ROOT) + '/v4/recommender/career_to_job',
    method: 'POST',
    data,
  })
}